import * as actionsTypes from "../actions/actionTypes";

import axiosInstance from "../../utils/axiosInstance";

export const usersStart = () => {
  return {
    type: actionsTypes.USERS_START,
  };
};

export const usersError = (errorMsg) => {
  return {
    type: actionsTypes.USERS_ERROR,
    errorMsg: errorMsg,
  };
};

export const currentUserDataSuccess = (data) => {
  return {
    type: actionsTypes.USER_CONNECT_INFO,
    userConnectInfo: data,
  };
};

export const getUserConnectedInfo = (id) => {
  return (dispatch) => {
    dispatch(usersStart());
    axiosInstance
      .get(`users/${id}`)
      .then((response) => {
        console.log(response.data);
        dispatch(currentUserDataSuccess(response.data.user));
      })
      .catch((err) => {
        dispatch(
          usersError(
            "Une Erreur c'est produite lors du chargement de la discussion"
          )
        );
      });
  };
};

export const getUserOnlineSuccess = (users) => {
  return {
    type: actionsTypes.USERS_ONLINE_SUCCESS,
    UserOnline: new Set(users),
  };
};
